import React from 'react';
import QuoteHistory from './QuoteHistory';
import QuoteDocuments from './QuoteDocuments';
import ReassignQuote from './ReassignQuote';
import { modal } from '../modal/ModalEmitter';
import ApiService from '../../services/ApiService';
import toastr from '../toastr';
import SalesQueryClient from './SalesQueryClient';

export const handleHistory = quoteId => {
  modal.open('QuoteHistory', {
    title: `Quote History ${quoteId}`,
    size: 'lg',
    style: 'center',
    hidePrint: true,
    message: <QuoteHistory quoteId={Number(quoteId)} />,
  });
};

export const handleDocuments = quoteId => {
  modal.open('QuoteDocuments', {
    title: `Quote Documents ${quoteId}`,
    size: 'md',
    style: 'center',
    hidePrint: true,
    message: <QuoteDocuments quoteId={Number(quoteId)} />,
  });
};

export const handleCancel = quoteId => {
  modal.confirm({
    message: `Are you sure you want to cancel '${quoteId}'`,
    callback: () => {
      ApiService.delete(`/crm/quote/${quoteId}`).then(() => {
        SalesQueryClient.invalidateQueries('my-quotes');
        SalesQueryClient.invalidateQueries('closed-quotes');
        SalesQueryClient.invalidateQueries('open-quotes');
      });
    },
  });
};

export const handleRequestApproval = quoteId => {
  ApiService.put(`/crm/quote/${quoteId}/request-approval`).then(() => {
    SalesQueryClient.invalidateQueries('my-quotes');
    toastr.success('Approval Requested', `Quote ${quoteId}`);
  });
};

export const handleReopen = quoteId => {
  console.log(quoteId);
};

export const handleReassign = (quoteId, assignedTo) => {
  modal.open('ReassignQuote', {
    title: `Reassign Quote ${quoteId}`,
    size: 'md',
    style: 'center',
    hidePrint: true,
    hideFooter: true,
    message: <ReassignQuote quoteId={Number(quoteId)} assignedTo={assignedTo} />,
  });
};

export const handleApprove = (quoteId) => {
  ApiService.put(`/crm/quote/${quoteId}/approve`).then(() => {
    SalesQueryClient.invalidateQueries('my-quotes');
    toastr.success('Approved', `Quote ${quoteId}`);
  });
};

